// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  color: red;
}
.fcombo {
  border: none !important;
}

.labelCombo {
  color: inherit;
  background: transparent !important;
  border: 0;
  width: 100%;
  word-wrap: break-word;
  font-size: 0.75rem;
  white-space: break-spaces;
  height: 100%;
}
.labelCombo.form-control:disabled,
.labelCombo.form-control:disabled:hover,
.labelCombo.form-control:disabled:focus,
.labelCombo.form-control[readonly],
.labelCombo.form-control[readonly]:hover,
.labelCombo.form-control[readonly]:focus,
select.labelCombo:disabled,
select.labelCombo:disabled:hover,
select.labelCombo:disabled:focus {
  background: transparent !important;
}

.errorText .errorIcon {
  position: absolute;
  top: 50%;
  left: 0;
  font-size: 0.821rem;
  font-weight: 600;
  transform: translateY(-50%);
  color: #ff3d71;
  font-style: normal;
}

.fgError .errorText {
  padding: 2px 16px 5px;
}

select {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
}

select:focus {
  background-image: linear-gradient(45deg, #333 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, #333 50%);
  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
  outline: 0;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

.hidenLabel {
  padding: 0;
  margin: -17px 2px;
}
/* .radioGrp .form-check .form-check-input:disabled,
.checkBoxGrp .form-check .form-check-input:disabled,
.form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1;
} */

.form-control:disabled,
.form-control:disabled:hover,
.form-control:disabled:focus,
.form-control[readonly],
.form-control[readonly]:hover,
.form-control[readonly]:focus,
select:disabled,
select:disabled:hover,
select:disabled:focus {
  background-color: #d4d4d4;
}

.form-control:disabled:hover,
.form-control:disabled:focus,
.form-control[readonly],
.form-control[readonly]:hover,
.form-control[readonly]:focus,
select:disabled,
select:disabled:hover,
select:disabled:focus {
  background-color: #d4d4d4;
}

input[type='checkbox']:disabled,
input[type='radio']:disabled,
input[type='checkbox'].disabled,
input[type='radio'].disabled,
.form-check-input:disabled,
select.disabled {
  pointer-events: none;
}

input[type='checkbox']:disabled ~ label::before,
input[type='radio']:disabled ~ label::before,
input[type='checkbox'].disabled ~ label::before,
input[type='radio'].disabled ~ label::before,
.form-check-input:disabled ~ label::before,
select.disabled ~ label::before {
  border-color: #d4d4d4;
}

input[type='checkbox']:disabled ~ label,
input[type='radio']:disabled ~ label,
input[type='checkbox'].disabled ~ label,
input[type='radio'].disabled ~ label,
.form-check-input:disabled ~ label,
select.disabled ~ label {
  /*color: #d4d4d4;*/
  opacity: 0.5;
}

.radioGrpBox input[type='radio']:disabled ~ label,
.radioGrpBox input[type='radio'].disabled ~ label,
.radioGrpBox .form-check-input:disabled ~ label,
select.disabled ~ label {
  background-color: #d4d4d4;
}

input[type='checkbox']:disabled ~ label::before,
input[type='checkbox'].disabled ~ label::before {
  background: #d4d4d4;
  border: 1px solid #8f9bb3;
}

input[type='text']::placeholder {
  font-size: 0.85rem;
}

/***** Help API section css starts here *****/
.help_container {
  align-items: flex-end;
  display: flex;
}
.help_section {
  display: inline-block;
  width: 100%;
}
.help_section > div {
  display: inline-flex;
}
.help_section div > div:last-child {
  position: relative;
  white-space: normal;
  margin-bottom: 5px;
  margin-left: 5px;
  display: inline-block;
  line-height: 1.5;
  word-break: break-word;
  /* min-width: 285px; */
  max-width: 100%;
}

.help_section div > div:last-child div {
  min-width: 345px;
  width: 100%;
  text-align: left;
  padding: 4px 0px 2px 10px;
  display: flex;
}
/* .help_section div > div:first-child {
  text-align: left;
} */
/* .help_section div > div:last-child {
  text-align: right;
} */
/* .help_section div > div:last-child div > div {
  text-align: left;
} */
/* .help_section span:last-child span {
  min-width: 280px;
  max-width: 100%;
  display: inline-block;
} */

/* .help_section span:last-child span div {
  text-align: left;
  display: flex;
} */
.help_section div:last-child div > div {
  display: flex;
}

.help_section div > div:last-child div > span:first-child {
  color: #ff3d71;
  min-width: 120px;
  max-width: 120px;
  font-size: 0.7rem;
}
.help_section div > div:last-child div > span:last-child {
  color: #3d98ff;
  font-size: 0.78rem;
}

.help_div .form-group {
  padding: 0 !important;
  font-size: 0.866rem;
  font-weight: 100;
  margin-bottom: 1px;
}

.help_div .help_section.form-group {
  height: 23px;
  display: flex;
  align-items: center;
}
.help_div .help_section.form-group div {
  margin-bottom: 0;
}

.help_div .form-control {
  height: 23px;
  padding: 0.2rem 0.33rem !important;
  font-size: 0.79rem;
  font-weight: 100;
  line-height: 1;
}

.help_div .ng-select.ng-select-single .ng-select-container {
  height: 26px !important;
}

.help_div label,
.help_div .label {
  font-size: 0.725rem;
  margin: 0;
  padding-top: 0.2rem;
}

.help_div select {
  background-position: calc(100% - 13px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px) !important;
}

.help_div select:focus {
  background-position: calc(100% - 5px) calc(1rem + -7px), calc(100% - 10px) calc(1rem + -7px) !important;
}

.help_div .input-group > .input-group-append > .btn,
.help_div .input-group > .input-group-append > .input-group-text,
.help_div .input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.help_div .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child),
.help_div .input-group > .input-group-prepend:not(:first-child) > .btn,
.help_div .input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  min-height: 15px !important;
  height: 21px !important;
  max-height: 21px !important;
}

.help_div .checkBoxGrp .form-check > .form-check-input ~ label::before {
  width: 12px;
  height: 12px;
}

/***** Help API section css ends here *****/

/***** Tooltip for displaying info starts here *****/
.tooltip-label-info-container {
  min-width: 250px;
  width: 100%;
  max-width: 300px;
  min-height: 50px;
  font-size: 0.99rem;
  line-height: 1.2;
  text-align: left;
  padding: 5px;
  font-weight: 200;
  white-space: normal;
  font-style: normal;
  background: rgb(234 234 79 / 50%);
}

.tooltip-label-info {
  font-size: 1.2rem;
  color: #317d03;
  position: relative;
  white-space: normal;
  font-style: normal;
  line-height: 0;
}

.tooltip-label-info:before {
  content: '\\f29c';
  font-family: 'FontAwesome';
}
/***** Tooltip for displaying info ends here *****/
.toggle-button-text {
  display: flex;
}

.btn-toggle {
  margin: 0 0.54rem;
  padding: 0;
  position: relative;
  border: none;
  min-height: 1.65rem;
  width: 3rem;
  border-radius: 1.5rem;
  color: #6b7381;
  background: #bdc1c8;
}
.btn-toggle:focus,
.btn-toggle.focus,
.btn-toggle:focus.active,
.btn-toggle.focus.active {
  outline: none;
}
.btn-toggle:before,
.btn-toggle:after,
.switchBtn .switchBtn-left,
.switchBtn .switchBtn-right {
  line-height: 1rem;
  /* width: 4rem; */
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  /* text-transform: uppercase; */
  letter-spacing: 1px;
  /* position: absolute; */
  /* bottom: 0; */
  transition: opacity 0.25s;
  color: #8f9bb3;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  white-space: normal;
  margin-top: 5px;
}

.btn-toggle > .handle {
  position: absolute;
  top: 0.2575rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.active {
  transition: background-color 0.25s;
}
.btn-toggle.active > .handle {
  left: 1.6875rem;
  transition: left 0.25s;
}
.btn-toggle.active:before,
.switchBtn .switchBtn-left > .btn-toggle.active {
  opacity: 0.5;
}
.btn-toggle.active:after,
.switchBtn .switchBtn-right {
  opacity: 1;
}
.btn-toggle:before,
.btn-toggle:after {
  color: #6b7381;
}
.btn-toggle.active {
  background-color: #36f;
}

.switchBtn-right {
  line-height: 1.8;
}
.toggle-button-text-on,
.toggle-button-text-off {
  float: left;
  width: 50%;
  height: 100%;
  line-height: 25px;
  font-family: Lato, sans-serif;
  font-weight: bold;
  color: #fff;
  text-align: center;
  font-size: 0.7rem;
}

.btn-toggle > .handle {
  width: 2rem;
  height: 1.29rem;
  top: 0.2511rem;
}

.btn-toggle.active > .handle {
  left: 1.85rem !important;
}

.opacity-0 {
  opacity: 0;
}

.industry_mob {
  display: grid;
  grid-column-gap: 2px;
  grid-template-columns: 90% 10%;
}

.ptForLabel {
  padding-top: 1.804rem;
}

.ptForLabelRadioImage {
  padding-top: 2.0599rem;
}

/* FormReadOnly CSS changes starts here*/
.form-groupReadonly {
  display: flex;
  flex-direction: row;
  margin-bottom: 6px;
}

.label-container {
  flex: 0 0 auto;
  width: 150px;
  margin-right: 10px;
  word-wrap: break-word;
}

.gridLabel-container {
  flex: 0 0 auto;
  word-wrap: break-word;
  max-width: 6.25rem;
  padding-top: 4px;
  margin-bottom: -5px;
}

.form-groupReadonly .input-container {
  flex: 1;
}

.input_isFormReadOnly {
  /* font-size: smaller; */
  font-size: 1rem;
  word-wrap: break-word;
  align-items: center;
}

.form-groupReadonly.topDownFieldClass {
  flex-direction: column;
}
/* FormReadOnly CSS changes ends here*/
`, "",{"version":3,"sources":["webpack://./src/app/system-common/field-group/field-group.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;;;;;;;;;EASE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;sDACoD;EACpD,wFAAwF;EACxF,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;sDACoD;EACpD,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;;;;;GAKG;;AAEH;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;;;EAME,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;AACA;;GAEG;AACH;;GAEG;AACH;;GAEG;AACH;;;;GAIG;;AAEH;;;GAGG;AACH;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,uGAAuG;AACzG;;AAEA;;;;;;EAME,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2CAA2C;;AAE3C,oDAAoD;AACpD;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,kDAAkD;AAClD;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA,sCAAsC","sourcesContent":[".error {\n  color: red;\n}\n.fcombo {\n  border: none !important;\n}\n\n.labelCombo {\n  color: inherit;\n  background: transparent !important;\n  border: 0;\n  width: 100%;\n  word-wrap: break-word;\n  font-size: 0.75rem;\n  white-space: break-spaces;\n  height: 100%;\n}\n.labelCombo.form-control:disabled,\n.labelCombo.form-control:disabled:hover,\n.labelCombo.form-control:disabled:focus,\n.labelCombo.form-control[readonly],\n.labelCombo.form-control[readonly]:hover,\n.labelCombo.form-control[readonly]:focus,\nselect.labelCombo:disabled,\nselect.labelCombo:disabled:hover,\nselect.labelCombo:disabled:focus {\n  background: transparent !important;\n}\n\n.errorText .errorIcon {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  font-size: 0.821rem;\n  font-weight: 600;\n  transform: translateY(-50%);\n  color: #ff3d71;\n  font-style: normal;\n}\n\n.fgError .errorText {\n  padding: 2px 16px 5px;\n}\n\nselect {\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%),\n    linear-gradient(135deg, gray 50%, transparent 50%);\n  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n}\n\nselect:focus {\n  background-image: linear-gradient(45deg, #333 50%, transparent 50%),\n    linear-gradient(135deg, transparent 50%, #333 50%);\n  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n  outline: 0;\n}\n\nselect:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n.hidenLabel {\n  padding: 0;\n  margin: -17px 2px;\n}\n/* .radioGrp .form-check .form-check-input:disabled,\n.checkBoxGrp .form-check .form-check-input:disabled,\n.form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1;\n} */\n\n.form-control:disabled,\n.form-control:disabled:hover,\n.form-control:disabled:focus,\n.form-control[readonly],\n.form-control[readonly]:hover,\n.form-control[readonly]:focus,\nselect:disabled,\nselect:disabled:hover,\nselect:disabled:focus {\n  background-color: #d4d4d4;\n}\n\n.form-control:disabled:hover,\n.form-control:disabled:focus,\n.form-control[readonly],\n.form-control[readonly]:hover,\n.form-control[readonly]:focus,\nselect:disabled,\nselect:disabled:hover,\nselect:disabled:focus {\n  background-color: #d4d4d4;\n}\n\ninput[type='checkbox']:disabled,\ninput[type='radio']:disabled,\ninput[type='checkbox'].disabled,\ninput[type='radio'].disabled,\n.form-check-input:disabled,\nselect.disabled {\n  pointer-events: none;\n}\n\ninput[type='checkbox']:disabled ~ label::before,\ninput[type='radio']:disabled ~ label::before,\ninput[type='checkbox'].disabled ~ label::before,\ninput[type='radio'].disabled ~ label::before,\n.form-check-input:disabled ~ label::before,\nselect.disabled ~ label::before {\n  border-color: #d4d4d4;\n}\n\ninput[type='checkbox']:disabled ~ label,\ninput[type='radio']:disabled ~ label,\ninput[type='checkbox'].disabled ~ label,\ninput[type='radio'].disabled ~ label,\n.form-check-input:disabled ~ label,\nselect.disabled ~ label {\n  /*color: #d4d4d4;*/\n  opacity: 0.5;\n}\n\n.radioGrpBox input[type='radio']:disabled ~ label,\n.radioGrpBox input[type='radio'].disabled ~ label,\n.radioGrpBox .form-check-input:disabled ~ label,\nselect.disabled ~ label {\n  background-color: #d4d4d4;\n}\n\ninput[type='checkbox']:disabled ~ label::before,\ninput[type='checkbox'].disabled ~ label::before {\n  background: #d4d4d4;\n  border: 1px solid #8f9bb3;\n}\n\ninput[type='text']::placeholder {\n  font-size: 0.85rem;\n}\n\n/***** Help API section css starts here *****/\n.help_container {\n  align-items: flex-end;\n  display: flex;\n}\n.help_section {\n  display: inline-block;\n  width: 100%;\n}\n.help_section > div {\n  display: inline-flex;\n}\n.help_section div > div:last-child {\n  position: relative;\n  white-space: normal;\n  margin-bottom: 5px;\n  margin-left: 5px;\n  display: inline-block;\n  line-height: 1.5;\n  word-break: break-word;\n  /* min-width: 285px; */\n  max-width: 100%;\n}\n\n.help_section div > div:last-child div {\n  min-width: 345px;\n  width: 100%;\n  text-align: left;\n  padding: 4px 0px 2px 10px;\n  display: flex;\n}\n/* .help_section div > div:first-child {\n  text-align: left;\n} */\n/* .help_section div > div:last-child {\n  text-align: right;\n} */\n/* .help_section div > div:last-child div > div {\n  text-align: left;\n} */\n/* .help_section span:last-child span {\n  min-width: 280px;\n  max-width: 100%;\n  display: inline-block;\n} */\n\n/* .help_section span:last-child span div {\n  text-align: left;\n  display: flex;\n} */\n.help_section div:last-child div > div {\n  display: flex;\n}\n\n.help_section div > div:last-child div > span:first-child {\n  color: #ff3d71;\n  min-width: 120px;\n  max-width: 120px;\n  font-size: 0.7rem;\n}\n.help_section div > div:last-child div > span:last-child {\n  color: #3d98ff;\n  font-size: 0.78rem;\n}\n\n.help_div .form-group {\n  padding: 0 !important;\n  font-size: 0.866rem;\n  font-weight: 100;\n  margin-bottom: 1px;\n}\n\n.help_div .help_section.form-group {\n  height: 23px;\n  display: flex;\n  align-items: center;\n}\n.help_div .help_section.form-group div {\n  margin-bottom: 0;\n}\n\n.help_div .form-control {\n  height: 23px;\n  padding: 0.2rem 0.33rem !important;\n  font-size: 0.79rem;\n  font-weight: 100;\n  line-height: 1;\n}\n\n.help_div .ng-select.ng-select-single .ng-select-container {\n  height: 26px !important;\n}\n\n.help_div label,\n.help_div .label {\n  font-size: 0.725rem;\n  margin: 0;\n  padding-top: 0.2rem;\n}\n\n.help_div select {\n  background-position: calc(100% - 13px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px) !important;\n}\n\n.help_div select:focus {\n  background-position: calc(100% - 5px) calc(1rem + -7px), calc(100% - 10px) calc(1rem + -7px) !important;\n}\n\n.help_div .input-group > .input-group-append > .btn,\n.help_div .input-group > .input-group-append > .input-group-text,\n.help_div .input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.help_div .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child),\n.help_div .input-group > .input-group-prepend:not(:first-child) > .btn,\n.help_div .input-group > .input-group-prepend:not(:first-child) > .input-group-text {\n  min-height: 15px !important;\n  height: 21px !important;\n  max-height: 21px !important;\n}\n\n.help_div .checkBoxGrp .form-check > .form-check-input ~ label::before {\n  width: 12px;\n  height: 12px;\n}\n\n/***** Help API section css ends here *****/\n\n/***** Tooltip for displaying info starts here *****/\n.tooltip-label-info-container {\n  min-width: 250px;\n  width: 100%;\n  max-width: 300px;\n  min-height: 50px;\n  font-size: 0.99rem;\n  line-height: 1.2;\n  text-align: left;\n  padding: 5px;\n  font-weight: 200;\n  white-space: normal;\n  font-style: normal;\n  background: rgb(234 234 79 / 50%);\n}\n\n.tooltip-label-info {\n  font-size: 1.2rem;\n  color: #317d03;\n  position: relative;\n  white-space: normal;\n  font-style: normal;\n  line-height: 0;\n}\n\n.tooltip-label-info:before {\n  content: '\\f29c';\n  font-family: 'FontAwesome';\n}\n/***** Tooltip for displaying info ends here *****/\n.toggle-button-text {\n  display: flex;\n}\n\n.btn-toggle {\n  margin: 0 0.54rem;\n  padding: 0;\n  position: relative;\n  border: none;\n  min-height: 1.65rem;\n  width: 3rem;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n}\n.btn-toggle:focus,\n.btn-toggle.focus,\n.btn-toggle:focus.active,\n.btn-toggle.focus.active {\n  outline: none;\n}\n.btn-toggle:before,\n.btn-toggle:after,\n.switchBtn .switchBtn-left,\n.switchBtn .switchBtn-right {\n  line-height: 1rem;\n  /* width: 4rem; */\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  /* text-transform: uppercase; */\n  letter-spacing: 1px;\n  /* position: absolute; */\n  /* bottom: 0; */\n  transition: opacity 0.25s;\n  color: #8f9bb3;\n  position: relative;\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\n  white-space: normal;\n  margin-top: 5px;\n}\n\n.btn-toggle > .handle {\n  position: absolute;\n  top: 0.2575rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  transition: left 0.25s;\n}\n.btn-toggle.active {\n  transition: background-color 0.25s;\n}\n.btn-toggle.active > .handle {\n  left: 1.6875rem;\n  transition: left 0.25s;\n}\n.btn-toggle.active:before,\n.switchBtn .switchBtn-left > .btn-toggle.active {\n  opacity: 0.5;\n}\n.btn-toggle.active:after,\n.switchBtn .switchBtn-right {\n  opacity: 1;\n}\n.btn-toggle:before,\n.btn-toggle:after {\n  color: #6b7381;\n}\n.btn-toggle.active {\n  background-color: #36f;\n}\n\n.switchBtn-right {\n  line-height: 1.8;\n}\n.toggle-button-text-on,\n.toggle-button-text-off {\n  float: left;\n  width: 50%;\n  height: 100%;\n  line-height: 25px;\n  font-family: Lato, sans-serif;\n  font-weight: bold;\n  color: #fff;\n  text-align: center;\n  font-size: 0.7rem;\n}\n\n.btn-toggle > .handle {\n  width: 2rem;\n  height: 1.29rem;\n  top: 0.2511rem;\n}\n\n.btn-toggle.active > .handle {\n  left: 1.85rem !important;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.industry_mob {\n  display: grid;\n  grid-column-gap: 2px;\n  grid-template-columns: 90% 10%;\n}\n\n.ptForLabel {\n  padding-top: 1.804rem;\n}\n\n.ptForLabelRadioImage {\n  padding-top: 2.0599rem;\n}\n\n/* FormReadOnly CSS changes starts here*/\n.form-groupReadonly {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 6px;\n}\n\n.label-container {\n  flex: 0 0 auto;\n  width: 150px;\n  margin-right: 10px;\n  word-wrap: break-word;\n}\n\n.gridLabel-container {\n  flex: 0 0 auto;\n  word-wrap: break-word;\n  max-width: 6.25rem;\n  padding-top: 4px;\n  margin-bottom: -5px;\n}\n\n.form-groupReadonly .input-container {\n  flex: 1;\n}\n\n.input_isFormReadOnly {\n  /* font-size: smaller; */\n  font-size: 1rem;\n  word-wrap: break-word;\n  align-items: center;\n}\n\n.form-groupReadonly.topDownFieldClass {\n  flex-direction: column;\n}\n/* FormReadOnly CSS changes ends here*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
